import axios from 'axios';
import resourcesData from 'resourcesData.json';
import { ResourcesArr } from 'interfaces/components/resources';

export const getResources = async () => {
  return new Promise<ResourcesArr[]>((resolve, reject) => {
    axios
      // .get('https://private-93fbab-iconiq.apiary-mock.com/getResourcesData')
      .get('/api/getResources')
      .then(response => {
        resolve(response.data.data);
      })
      .catch(async () => {
        resolve(resourcesData as ResourcesArr[]);
      });
  });
};
